export default "__VITE_ASSET__BUN_YfrP__"